import { GridColDef } from "@mui/x-data-grid-pro";
import ItemStatus from "../../../../../../common/components/item_status";
import { IconButton } from "@mui/material";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";


type Props = {
    onActionEdit: (idMotivoDemissao: number | null, openState: boolean) => void,
    onActionDelete: (idMotivoDemissao: number | null, openState: boolean) => void,
}

export const GenerateCentroCustoListaColumns = ({
    onActionEdit,
    onActionDelete,
}: Props): GridColDef[] => {

    const computeItemStatusTitle = (status: number) => {
        switch (status) {
            case 0:
                return "Ativo";
            case 1:
                return "Bloqueado";
            case 2:
                return "Encerrado";
            default:
                return "?";
        }
    };

    const computeItemStatusColor = (status: number) => {
        switch (status) {
            case 0:
                return "green";
            case 1:
                return "red";
            case 2:
                return "yellow";
            default:
                return "blue";
        }
    };

    const computeItemStatusDescription = (status: number) => {
        switch (status) {
            case 0:
                return "Ativo";
            case 1:
                return "Bloqueado";
            case 2:
                return "Encerrado";
            default:
                return "?";
        }
    };
    return [
        {
            field: "status",
            filterable: false,
            headerName: "Status",
            minWidth: 120,
            width: 120,
            sortable: false,
            renderCell: (params) => (
                <div className="w-full h-full flex justify-center items-center">
                    <ItemStatus
                        size="autowidth"
                        title={computeItemStatusTitle(params.value)}
                        color={computeItemStatusColor(params.value)}
                        description={computeItemStatusDescription(params.value)} />
                </div>
            )
        },
        {
            field: "codigo",
            filterable: false,
            headerName: "Código",
            minWidth: 130,
            width: 200,
            sortable: false,
        },
        {
            field: "descricao",
            filterable: false,
            flex: 1,
            headerName: "Descrição",
            sortable: false,
        },
        {
            field: 'idCentroCusto',
            sortable: false,
            filterable: false,
            headerName: 'Ações',
            minWidth: 100,
            renderCell: (params) => {
                return (
                    <div className="flex items-center justify-center w-full h-full gap-2">
                        <IconButton onClick={() => onActionEdit(params.value, true)}>
                            <DynamicIcon nameIcon="EditRounded" size={25} className="dark:text-white text-primary-green" />
                        </IconButton>

                        <IconButton onClick={() => onActionDelete(params.value, true)}>
                            <DynamicIcon nameIcon="DeleteForeverRounded" size={25} className="text-red-500" />
                        </IconButton>
                    </div>
                );
            }
        }

    ];

}